import { RoutingService } from './../../../security/services/routing.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-page-found',
  templateUrl: './no-page-found.component.html',
  styles: [],
})
export class NoPageFoundComponent implements OnInit {

  constructor(private routingService: RoutingService) { }

  ngOnInit() { }

  goHome() {
    this.routingService.navigateHome();
  }
}
